import assets from "@/data/publicAssets.json";
import { localImageSet } from "./imageSources";
const versions: Record<string, string> = assets.versions;
const alternatives: Record<string, string> = assets.alternatives;
export function publicAsset(src: string | undefined): string | undefined {
  if (!src || !src.startsWith("/") || src.includes("?") || !import.meta.env.PROD) return src;
  const target = alternatives[src] || src;
  return versions[target] ? `${target}?v=${versions[target]}` : target;
}
export function publicSrcSet(srcSet: string | undefined) {
  return srcSet?.split(",").map((candidate) => {
    const [url, ...descriptor] = candidate.trim().split(/\s+/);
    return [publicAsset(url), ...descriptor].join(" ");
  }).join(", ");
}
export function responsiveImageSet(srcSet: string | undefined, format: "avif" | "webp") {
  if (!import.meta.env.PROD) return format === "webp" ? srcSet : undefined;
  return localImageSet(srcSet, format, assets) ?? (format === "webp" ? publicSrcSet(srcSet) : undefined);
}
